import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initComponents, initLayouts } from './components'
import { initValidations } from './validation'
import { layoutSystem } from '@ezio/ui'
import alertBox from '@ezio/ui/overlays/alert-box'
import modalBox from '@ezio/ui/overlays/modal-box'
import imageBox from '@ezio/ui/overlays/image-box'
import galleryBox from '@ezio/ui/overlays/gallery-box'
import fileUploadBox from '@ezio/ui/overlays/file-upload-box'

import { useEzioAPI } from '@ezio/services'
import { useEzioWs } from '@ezio/services'
import { createPinia } from 'pinia'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import { reset } from './stores'

import Notifications from '@kyvg/vue3-notification'
import { useTokensStore } from '@ezio/features/tokens'

const app = createApp(App)
app.use(createPinia())

app.use(layoutSystem, {
    defaultLayout: 'Dashboard'
})
app.use(router)
app.use(Notifications)

app.use(alertBox)
app.use(modalBox)
app.use(imageBox)
app.use(galleryBox)
app.use(fileUploadBox)

const { api } = useEzioAPI()
api.tokensStore = useTokensStore()
api.onLoggingOut(() => {
    reset()
    router.push('/sign-in')
})

const { ws } = useEzioWs()
ws.setTokensStore(useTokensStore())

initComponents(app)
initLayouts(app)
initValidations()
dayjs.locale('fr')

app.mount('#app')

export default app
